export const TITLE = 'Аналитика';
export const OUT = 'Да, выйти';
